import { API_URL as untypedApiUrl } from "../../spond-web-common-js/src/js/constants";

export const API_URL = untypedApiUrl as string;
export const API_LEVEL = "2.5.57";
